
import { Helmet } from "react-helmet";
import { SCHEMA_MAP } from "../conf/schemas/getSchemaData";

const safelyParseMetaDescription = (str) => {
    if(!str) return null;
    return str.replace(/"/g, '&quot;');
}

const removeTrailingSlash = (path) => path?.endsWith("/") ? path.slice(0, -1) : path;


export const SEOHeaders = ({ title, path, metaDescription, index = false, follow = false, schemas = [] }) => {
  const schemaEntries = schemas
    .map(key => ({ key, data: SCHEMA_MAP[key] }))
    .filter(({ data }) => data);

  return (
    <Helmet>
      <title>{title}</title>
      {path && <link rel="canonical" href={`https://${window.location.host}${removeTrailingSlash(path)}`} />}
      <meta
        name="robots"
        content={`${index ? "index" : "noindex"}, ${
          follow ? "follow" : "nofollow"
        }`}
      />
      {metaDescription && (
        <meta name="description" content={safelyParseMetaDescription(metaDescription)} />
      )}
      {schemaEntries.map(({ key, data }) => (
        <script key={key} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};
